import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import HeaderTopbar from "./HeaderTopbar";
import HeaderNav from "./HeaderNav";
import HeaderActions from "./HeaderActions";
import HeaderMobileMenu from "./HeaderMobileMenu";
import CartDrawer from "./CartDrawer";
import SearchModal from "../SearchModal";

/** Site-wide header. Owns lightweight UI state (scrolled, mobile menu, search,
 * cart, active dropdown) and delegates rendering to the focused sub-components. */
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [openMobile, setOpenMobile] = useState(false);
  const [openDrop, setOpenDrop] = useState(null);
  const [openSearch, setOpenSearch] = useState(false);
  const [openCart, setOpenCart] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpenMobile(false);
    setOpenDrop(null);
  }, [location.pathname]);

  useEffect(() => {
    const handler = () => setOpenCart(true);
    window.addEventListener("md-cart-open", handler);
    return () => window.removeEventListener("md-cart-open", handler);
  }, []);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setOpenSearch(true);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <>
      <HeaderTopbar />

      <header className={`md-header ${scrolled || openMobile ? "md-header-scrolled" : ""}`} data-testid="site-header">
        <div className="md-container flex items-center justify-between md-header-row">
          <Link to="/" className="flex items-center gap-2" data-testid="logo-home-link">
            <img src="/logo.png" alt="MindDhara" className="h-12 md:h-14 w-auto" />
          </Link>

          <HeaderNav openDrop={openDrop} setOpenDrop={setOpenDrop} />

          <HeaderActions onOpenSearch={() => setOpenSearch(true)} onOpenCart={() => setOpenCart(true)} />

          <button className="lg:hidden p-2" onClick={() => setOpenMobile(!openMobile)} data-testid="mobile-menu-toggle" aria-label="Toggle menu">
            {openMobile ? <X size={24} /> : <List size={24} />}
          </button>
        </div>

        {openMobile && (
          <HeaderMobileMenu
            onClose={() => setOpenMobile(false)}
            onOpenSearch={() => setOpenSearch(true)}
          />
        )}

        {openSearch && <SearchModal onClose={() => setOpenSearch(false)} />}
      </header>

      <CartDrawer open={openCart} onClose={() => setOpenCart(false)} />
    </>
  );
}
